import React, { useState, useEffect } from "react";
import HelpIcon from "../../assets/images/help-icon.svg";
import CrossIcon from "../../assets/images/grey_ai_cross.svg";
import GreenArrowIcon from "../../assets/images/call_made_new.svg";
import { useGetPromptsList } from "repositories/ai-assistant-repository";
import constants from "../../constants";
import useHandleApiError from "hooks/useHandleApiError";
import InfiniteScroll from "react-infinite-scroll-component";
import { uniqBy } from "lodash";
import { withTranslation } from "react-i18next";

const PAGE_SIZE = constants.pageSize;
function AssistantCard({ t, setShowAssistantCard, onSendMessage }) {
  const [pageNumber, setPageNumber] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [promptList, setPromptList] = useState([]);

  const {
    isLoading,
    data,
    isFetching,
    error: isError,
  } = useGetPromptsList(pageNumber, PAGE_SIZE);
  useHandleApiError(isLoading, isFetching, isError);

  useEffect(() => {
    if (!isLoading && data && data?.items?.length > 0) {
      setPromptList((prev) => uniqBy([...prev, ...data?.items], "id"));

      setTotalItems(data?.totalCount);
    }
  }, [isLoading, data]);

  return (
    <div className="assistant-card">
      <div className="assistant-header">
        <div className="assistant-title">
          <img src={HelpIcon} alt="Help" />
          {t("aiAssistant.onlineHelp")}
        </div>
        <img
          src={CrossIcon}
          alt="Close"
          className="close-icon"
          onClick={() => setShowAssistantCard(false)}
          style={{ cursor: "pointer" }}
        />
      </div>
      {(isLoading || isFetching) && (
        <div className="text-placeholder-200 shimmer-animation"></div>
      )}
      <InfiniteScroll
        className="w-100"
        dataLength={promptList?.length}
        hasMore={promptList?.length < totalItems}
        next={() => setPageNumber((v) => v + 1)}
      >
        <div className="assistant-links">
          {promptList &&
            promptList?.map((prompt) => (
              <a
                className="cursor-pointer"
                onClick={() => onSendMessage(prompt?.promptName)}
                key={prompt?.id}
              >
                <img src={GreenArrowIcon} alt="" /> {prompt?.promptName}
              </a>
            ))}
        </div>
      </InfiniteScroll>
    </div>
  );
}

export default withTranslation()(AssistantCard);
